import styled from "styled-components";
import backgroundImg from "../../../../assets/images/background_nop.png";

export const Row = styled.div``;

export const Col = styled.div``;

export const Div = styled.div``;

export const Container = styled.div`
  ${(props) =>
    !props.theme?.isDarkTheme && `background-image: url(${backgroundImg});`}
  height: 100%;
  background-size: cover !important;
  overflow: hidden;
`;
